// Utilities for detecting dynamic import / chunk load failures,
// e.g. "Failed to fetch dynamically imported module", "Unable to preload CSS",
// or "invalid mime type text/html" that often occur after deploys when stale
// HTML/JS references removed hashed assets.

export const isDynamicImportChunkError = (error: unknown): boolean => {
  if (!error) return false;

  const message =
    typeof (error as any).message === 'string' ? (error as any).message : typeof error === 'string' ? error : '';
  const name = typeof (error as any).name === 'string' ? (error as any).name : '';

  if (!message) return false;

  const lowerMessage = message.toLowerCase();

  return (
    // Failed to fetch errors
    // Syntax errors when HTML is parsed as JavaScript (common when 404 returns HTML)
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Failed to fetch') ||
    (name === 'TypeError' && message.includes('dynamically imported module')) ||
    // Vite CSS preload failure when a lazy chunk's hashed stylesheet is gone after deploy
    // e.g. "Unable to preload CSS for /assets/ExpandableTable-D1pfxmHv.css"
    lowerMessage.includes('unable to preload css') ||
    // MIME type errors (when server returns HTML instead of JS chunk)
    lowerMessage.includes('mime type') ||
    lowerMessage.includes('text/html') ||
    lowerMessage.includes('non-javascript mime type') ||
    (name === 'SyntaxError' &&
      (lowerMessage.includes('unexpected token') || lowerMessage.includes('unexpected token <')))
  );
};
